import React from 'react';
import IndustriesIndex from '../../../pages/IndustriesIndex';
import IndustryPage from '../../../pages/IndustryPage';

export const industriesRoutes = [
  { path: '/industries', element: <IndustriesIndex /> },
  { path: '/industries/:slug', element: <IndustryPage /> }
];
